import _ from 'underscore';
import { ProjectionGridBaseColumn } from '@bingads-webui/projection-grid-base-column';
import { fromLegacyTimeZone, toIANATimeZone } from '@bingads-webui-universal/time-zone-converter';
import template from './one-line-text.pug';

export class StartTimeColumn extends ProjectionGridBaseColumn {
  constructor({ i18n, appConfig }) {
    const title = i18n.getString('ColumnName_StartTime');
    super({
      name: 'StartTime',
      property: 'RecommendationResult/StartTime',
      title,
      bodyClasses: ['grid-column-start-time'],
      colClasses: ['col-text'],
      helpId: 'Pop_BA_Recommendations_MCC_StartTime',
      helpAriaLabel: i18n.getString('Click to learn more about {{item}}', { item: title }),
    });
    this.appConfig = appConfig;
    this.i18n = i18n;
  }

  template({
    value: {
      Timestamp,
    },
  }) {
    const timeStamp = new Date(Timestamp);
    const accountTimeZone = toIANATimeZone(fromLegacyTimeZone(this.appConfig.get('AccountTimeZone')));
    const date = this.i18n.formatDate(timeStamp, { timeZone: accountTimeZone, datetime: 'medium' });

    return template({ content: date });
  }

  get property() {
    return {
      get: _.identity,
    };
  }
}
